import { render, staticRenderFns } from "./spam-sms-logs.vue?vue&type=template&id=a882a2fa&"
import script from "./spam-sms-logs.vue?vue&type=script&lang=js&"
export * from "./spam-sms-logs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports